import connect from './connect'
import SignInPage from './SignInPage'

export default connect(SignInPage)
